import { Badge } from "../ui/badge";
import { Users } from "lucide-react";
import type { ClientWithAudio } from "./types";
import { ClientResultCard } from "./ClientResultCard";

interface ClientResultsGridProps {
  clients: ClientWithAudio[];
  onPlayAudio: (client: ClientWithAudio) => void;
}

export const ClientResultsGrid = ({
  clients,
  onPlayAudio,
}: ClientResultsGridProps) => {
  if (!clients || clients.length === 0) return null;

  return (
    <div className="mt-6">
      <div className="flex items-center gap-2 mb-4">
        <Users className="h-5 w-5 text-muted-foreground" />
        <h3 className="text-base font-semibold text-foreground">
          Client Results
        </h3>
        <Badge variant="secondary" className="ml-auto">
          {clients.length} clients
        </Badge>
      </div>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-3 max-md:grid-cols-1">
        {clients.map((client) => (
          <ClientResultCard
            key={client.client_id}
            client={client}
            onPlayAudio={onPlayAudio}
          />
        ))}
      </div>
    </div>
  );
};
